/**
 * Module-level store for the engagement ID fetched from the site template.
 * Set once on app initialization, read by RoadieService on each construction.
 */
let engagementId: string | undefined;

export const setEngagementId = (id: string): void => {
  engagementId = id;
};

export const getEngagementId = (): string | undefined => engagementId;
